module.exports = __webpack_public_path__ + "static/media/bag.ab1b1206.jpg";